'use strict';

var AppState = require('app_state');
var Log = require('utils/log');
var ThemeUtils = require('utils/theme/utils');

// Extracted and adapted from 'jquery.app.js' (Ubold Admin Template 1.6)

var Resizing = {};

var debounce = function (func, wait, immediate) {
    var timeout, result;

    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(context, args);
        return result;
    };
};

var resizeitems = function () {
    if ($.isArray(resizefunc)) {
        for (var i = 0; i < resizefunc.length; i++) {
            window[resizefunc[i]]();
        }
    }
};

window.initscrolls = function () {
    if (jQuery.browser.mobile !== true) {
        //SLIM SCROLL
        $('.slimscroller').slimscroll({
            height: 'auto',
            size: '5px',
        });

        $('.slimscrollleft').slimScroll({
            height: 'auto',
            position: 'right',
            size: '5px',
            color: '#dcdcdc',
            wheelStep: 5,
        });
    }
};

window.changeptype = function () {
    var w = $(window).width();
    var h = $(window).height();
    var dw = $(document).width();
    var dh = $(document).height();

    if (jQuery.browser.mobile === true) {
        $('body').addClass('mobile').removeClass('fixed-left');
    }

    if (!$('#wrapper').hasClass('forced')) {
        if (w > 990) {
            AppState.menuIsExpanded = true;
            $('body').removeClass('smallscreen').addClass('widescreen');
            $('#wrapper').removeClass('enlarged');
        } else {
            AppState.menuIsExpanded = false;
            $('body').removeClass('widescreen').addClass('smallscreen');
            $('#wrapper').addClass('enlarged');
            $('.left ul').removeAttr('style');
        }
        if ($('#wrapper').hasClass('enlarged') && $('body').hasClass('fixed-left')) {
            $('body').removeClass('fixed-left').addClass('fixed-left-void');
        } else if (!$('#wrapper').hasClass('enlarged') && $('body').hasClass('fixed-left-void')) {
            $('body').removeClass('fixed-left-void').addClass('fixed-left');
        }
    }

    if (AppState.menuIsExpanded) {
        $('#sidebar-menu-toggle').addClass('enlarged');
        $('#sidebar-menu-toggle').find('i').attr('class', 'fa fa-angle-left');
    } else {
        $('#sidebar-menu-toggle').removeClass('enlarged');
        $('#sidebar-menu-toggle').find('i').attr('class', 'fa fa-angle-right');
    }

    ThemeUtils.toggle_slimscroll('.slimscrollleft');
};

Resizing.init = function () {
    Log.info('Resizing::Init');

    window.resizefunc.push('initscrolls');
    window.resizefunc.push('changeptype');

    $(window).resize(debounce(resizeitems, 100));
    $('body').trigger('resize');
};

module.exports = Resizing;
